import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import { m } from '../common/m';

export default class SpinnerComponent extends Component {
	constructor(props) {
		super();
		m.setThisSpinner(this);
		this.state = {
			show: !!(props.show),
		};
	}

	showSpinner() {
		this.setState({ show: true });
	}

	hideSpinner() {
		this.setState({ show: false });
	}

	render() {
		const { show } = this.state;
		return (
			<div className={show ? 'global-spinner show-spinner' : 'global-spinner'}>
				<CircularProgress />
			</div>
		);
	}
}
